import React from "react";
import SubPageLayout from "../components/SubPageLayout";
import OurWork from "../components/home/OurWork";
import FinalCta from "../components/home/FinalCta";

export default function GalleryPage() {
  return (
    <SubPageLayout testid="gallery-page" eyebrow="Our Work" title="Quality You Can See."
      subtitle="Real Honest Water LLC installations across Northern Virginia homes. More projects are added as we complete them."
      metaDescription="Photos of real Honest Water LLC water filtration, softener and reverse osmosis installations in Northern Virginia.">
      <OurWork bare />
      <FinalCta />
    </SubPageLayout>
  );
}
